import { useNavigate } from "react-router";

const Pagination = ({ listLength, path, page, filter, limit }) => {
    const navigate = useNavigate();

    const paginationPage = page === undefined ? 0 : page - 1;

    return(
        <ul className="pagination">
            {
                Array.from({ length: Math.max(Math.ceil(Number(listLength) / limit), 1) }, (_, i) => i + 1).map((pageNum, index) => <li className={ paginationPage === index ? "active" : "" } onClick={() => navigate(`${ path }/page/${ pageNum }${ filter ? `/${ filter }` : '' }`)} key={ index }>{ pageNum }</li>)
            }
        </ul>
    );
};

export default Pagination;